<template>
  <DefaultField
    :field="currentField"
    :errors="errors"
    :show-help-text="showHelpText"
    :full-width-content="fullWidthContent"
  >
    <template #field>
      <div class="flex items-center">
        <input
          type="time"
          class="form-control form-input form-control-bordered"
          ref="dateTimePicker"
          :id="currentField.uniqueKey"
          :dusk="field.attribute"
          :name="field.name"
          :value="value"
          :class="errorClasses"
          :disabled="currentlyIsReadonly"
          @change="handleChange"
          :min="currentField.min"
          :max="currentField.max"
          :step="currentField.step"
        />
      </div>
    </template>
  </DefaultField>
</template>

<script>
import isNil from 'lodash/isNil'
import { DateTime } from 'luxon'
import { DependentFormField, HandlesValidationErrors } from '@/mixins'

export default {
  mixins: [HandlesValidationErrors, DependentFormField],

  methods: {
    /*
     * Set the initial value for the field
     */
    setInitialValue() {
      if (isNil(this.currentField.value)) {
        return
      }

      const raw = this.currentField.value
      let parsed = DateTime.fromISO(raw)

      if (!parsed.isValid) {
        parsed = DateTime.fromFormat(raw, 'HH:mm:ss')
      }

      if (!parsed.isValid) {
        parsed = DateTime.fromFormat(raw, 'HH:mm')
      }

      this.value = parsed.isValid ? parsed.toFormat('HH:mm') : raw
    },

    /**
     * On save, populate our form data
     */
    fill(formData) {
      if (this.currentlyIsVisible) {
        this.fillIfVisible(formData, this.fieldAttribute, this.value)
      }
    },

    /**
     * Update the field's internal value
     */
    handleChange(event) {
      this.value = event?.target?.value ?? event

      if (this.field) {
        this.emitFieldValueChange(this.fieldAttribute, this.value)
      }
    },
  },
}
</script>
